import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { noop } from 'lib/functions/noop'
import Input from 'components/form/input'
import { ProbateEstate } from 'lib/models/probate-estate'
import useApi from 'lib/effects/api'
import styled from 'styled-components'

const StyledForm = styled(Form)`
  max-width: 400px;
`

export const EstateForm = ({
  probateEstate,
}: {
  probateEstate: ProbateEstate
}) => {
  const [{ data: probateEstateForm }, updateProbateEstate] =
    useApi<ProbateEstate>({ data: probateEstate })

  if (!probateEstateForm) return null

  const schema = Yup.object().shape({
    nationalInsuranceNumber: Yup.string()
      .nullable()
      .test(
        'nationalInsuranceNumber',
        'Must be exactly 9 letters and numbers only, no symbols or spaces',
        (value) => {
          if (!value || value.trim() === '') return true
          return /^[A-Z0-9]{9}$/i.test(value.trim())
        }
      ),
  })

  const handleSaveNationalInsuranceNumber = ({ value }: { value: string }) => {
    if (!schema.isValidSync({ nationalInsuranceNumber: value })) {
      return
    }
    updateProbateEstate({
      url: `/api/probate-estates/${probateEstate.id}`,
      method: 'PATCH',
      data: {
        data: {
          type: 'probate_estates',
          id: probateEstate.id,
          attributes: { nationalInsuranceNumber: value },
        },
      },
    })
  }

  return (
    <Formik
      initialValues={probateEstateForm.attributes}
      validationSchema={schema}
      enableReinitialize
      onSubmit={noop}
    >
      <StyledForm>
        <Input
          name="nationalInsuranceNumber"
          label="National insurance number of the deceased"
          hint="Write this without spaces or symbols (e.g. JJ872635E)"
          handleSave={handleSaveNationalInsuranceNumber}
        />
      </StyledForm>
    </Formik>
  )
}
